import gql from 'graphql-tag';

export const NOTE_FRAGMENT = gql`
  fragment NoteFragment on Note {
    id
    job_id
    account_id
    creator_user_id
    creatorFullName
    client_account_id
    estimate_id
    property_id
    invoice_id
    text
    isInternal
    createdAt
    updatedAt
  }
`;
